import * as React from 'react';
import {
  DateParam,
  NumberParam,
  QueryParamConfigMap,
  StringParam,
  useCustomSearchParams,
  withDefault,
} from 'common/hooks/customSearchParams';
import moment from 'moment';
import { DEFAULT_TIME } from './components/selectors/time-selector/times';
import { PerDiemArchiveMode } from './types';
import { useShowSmartPerDiem } from './hooks';

const getPerDiemParams: (smartPerDiem: boolean, withDefaults: boolean) => QueryParamConfigMap = (
  smartPerDiem,
  withDefaults
) => ({
  mode: withDefault(
    StringParam,
    smartPerDiem ? PerDiemArchiveMode.SmartPerDiem : PerDiemArchiveMode.SpecificDate
  ),
  container: withDefaults ? withDefault(StringParam, "20'") : StringParam,
  shippingLine: withDefaults ? withDefault(StringParam, 'MSC') : StringParam,
  startDate: withDefaults ? withDefault(DateParam, moment()) : DateParam,
  endDate: withDefaults ? withDefault(DateParam, moment()) : DateParam,
  time: withDefault(StringParam, DEFAULT_TIME.key),
  page: withDefault(NumberParam, 1),
  pageSize: withDefault(NumberParam, 50),
});

export const usePerDiemParams = (withDefaults = true) => {
  const smartPerDiem = useShowSmartPerDiem();
  const params = React.useMemo(
    () => getPerDiemParams(smartPerDiem, withDefaults),
    [smartPerDiem, withDefaults]
  );
  return useCustomSearchParams(params);
};
